module.exports = __webpack_public_path__ + "static/media/JeanKelley-Logo_003.858929e1.jpg";